<div class="row">
  <div class="ibox-content pos-relative">
    <app-content-template-form (onAfterSave)="afterSave($event)"></app-content-template-form>
  </div>
</div>
